import { SUPPORT_CHAT_INIT_EVENT_NAME } from '../../enums/consts';

export default () => {
    window.dispatchEvent(
        new CustomEvent(SUPPORT_CHAT_INIT_EVENT_NAME, {
            detail: {
                chat_id: 'business',
                department: 'Fiverr Business',
                tags: ['business', 'business_notification', 'reason_business_notification'],
                state: 'OPEN',
            },
        })
    );
};
